import { Menu, MenuItem } from '@blueprintjs/core';
import * as React from 'react';

import { TEST_IDS } from 'src/constants/testIds';
import { useRemoveSelection } from 'src/containers/ProjectDiagram/hooks/remove/useRemoveSelection';
import { useAddMappingWithSelection } from 'src/containers/ProjectDiagram/hooks/useAddMappingWithSelection';
import * as copy from 'src/templates/copy';

export const MultiSelectionContextMenu: React.VFC = () => {
  const { isNewMappingEnabled, handleAddMappingWithSelection } =
    useAddMappingWithSelection();
  const handleDeleteSelection = useRemoveSelection();

  return (
    <Menu>
      {isNewMappingEnabled ? (
        <MenuItem
          data-testid={TEST_IDS.projectDiagram.contextMenu.newMapping}
          onClick={handleAddMappingWithSelection}
          text={copy.components.projectDiagram.contextMenu.newMapping}
        />
      ) : null}
      <MenuItem
        data-testid={TEST_IDS.projectDiagram.contextMenu.delete}
        onClick={handleDeleteSelection}
        text={copy.components.projectDiagram.contextMenu.deleteMultiple}
      />
    </Menu>
  );
};
